import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";
import { useDispatch, useSelector } from "react-redux";
import PatientDetails from "./PatientDetails";
import { Change } from "../../../store/async-actions/digitalmarketing/header";
import { useParams } from "react-router-dom";
import {
  useGetAppoinmentbyIdQuery,
  useGetPatientDetailsbyIdQuery,
} from "../../../Service/appoinment";
import { useGetCustomerQuery } from "../../../Service/customers";
import { useGetCustomerAppointmentByCustomerIdQuery } from "../../../Service/CustomerAppointment";
import { useGetCustomerReminderByCustomerIdQuery } from "../../../Service/CustomerReminder";
import {
  useGetDashboardRemindedForQuery,
  useGetDashboardRemindedToQuery,
} from "../../../Service/dashboard";
import Toast from "../../../Component/DigitalMarketing/Toast";
import CustomerReminders from "./CustomerReminders";

function UpdateReminder() {
  const { id } = useParams();
  const { open, message, openSnackBar, type } = useSnackbar();
  const dispatch = useDispatch();
  const callBackforErrorMessage = (value = true) => {
    // setErrorMessage(value);
    // if (specialChractorValidation(CustomerDetail?.customerName)) {
    //   return "special chractor not allowed in user name field";
    // } else return "please enter user name !..";
  };


  useEffect(() => {
    const data: any = {
      first: "New Reminder",
    };
    dispatch(Change(data));
  }, []);
  return (
    <Row>
      <Toast open={open} type={type} message={message} />
      <Col md={6}>
        <div className="Appointment">
          <ul className="Appointment-ul md-bord">
            <CustomerReminders
              openSnackBar={openSnackBar}
              // details={response1.data}
              id={id}
              callBackforErrorMessage={callBackforErrorMessage}
            />
          </ul>
        </div>
      </Col>
    </Row>
  );
}

export default UpdateReminder;
